import { Component, OnInit } from '@angular/core'
import Swal from 'sweetalert2'
import { Router } from '@angular/router'
import { AuthenticationService } from '../../../_services/authentication.service'
import { RequestsService } from '../../../_shared/services/requests.service'

declare var jQuery: any

@Component({
  selector: 'app-animal',
  templateUrl: './animal.component.html',
  styleUrls: ['./animal.component.scss'],
})
export class AnimalComponent implements OnInit {
  animalName: string
  country_id: string
  countryName: string
  message: string
  animalsData: any
  animalCount: number
  filteredAnimals: any
  searchItem: string
  animalDescription: string
  file: any = null
  loading = false
  createAnimalIsSuccess: boolean
  createAnimalError: boolean
  requiredField: any = {
    animal: false,
    photo: false,
  }
  selectedLanguage: string = 'English'
  isLoadingAnimals: boolean
  isAddingAnimal: boolean
  chosenLanguage: string = 'English'

  constructor(
    private requestService: RequestsService,
    private authenticationService: AuthenticationService,
    private _router: Router
  ) {}

  quillConfig = {
    toolbar: [
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['bold', 'italic', 'underline'],
      [{ header: 1 }, { header: 2 }],
      ['clean'],
      ['link', 'image', 'video'],
    ],
  }

  editorStyle = {
    height: '100px',
    marginBottom: '10px',
  }

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country_id, country } = currentUser
    this.country_id = country_id
    this.countryName = country
    this.animalDescription = ''
    this.getAllAnimals()
  }

  onLanguageSelected(event) {
    this.selectedLanguage = event.target.value
    this.getAllAnimals()
  }

  getAllAnimals() {
    this.isAddingAnimal
      ? (this.isLoadingAnimals = false)
      : (this.isLoadingAnimals = true)
    this.requestService
      .dash_get(
        `animals/${this.countryName}/${this.selectedLanguage}`,
        null,
        true
      )
      .subscribe((res) => {
        this.isLoadingAnimals = false
        this.animalsData = res.data
        this.filteredAnimals = res.data
        this.animalCount = res.data.length
      })
  }

  getProductDetails(animalName: string, selectedLanguage: string) {
    localStorage.setItem('animal_name', animalName)
    localStorage.setItem('selected_language', selectedLanguage)
    this._router.navigateByUrl('/animal-details')
  }

  onLanguageChosen(event) {
    this.chosenLanguage = event.target.value
  }

  createAnimal(createAnimalForm) {
    this.loading = true
    let formData = new FormData()

    if (this.file) {
      formData.append('photo', this.file, this.file.name)
    }
    formData.append('animal', createAnimalForm.animals)
    formData.append('description', createAnimalForm.description)
    formData.append('language', this.chosenLanguage)

    this.requestService
      .dash_putWithImage(
        `animals/${this.countryName}/${this.chosenLanguage}`,
        formData,
        true
      )
      .subscribe(
        (response) => {
          this.loading = false
          this.isAddingAnimal = true
          if (response.success == true) {
            this.createAnimalIsSuccess = true
            this.message = 'Animal added successfully'
            this.getAllAnimals()
            const status = 'success'
            const title = status.charAt(0).toUpperCase() + status.slice(1)
            Swal.fire(title, this.message, status)
            this.resetAddAnimalModal()
          } else {
            this.createAnimalIsSuccess = false
            this.message = response.message
            this.createAnimalError = true
          }
        },
        (error) => this.handlerError(error)
      )
  }

  processImage(event) {
    const {
      target: { files },
    } = event
    if (
      files.length > 0 &&
      /\.(jpg|jpeg|png)$/i.test(files[0].name) &&
      files[0].size < 2000000
    ) {
      this.file = event.target.files[0]
    } else {
      this.requiredField.photo = true
    }
  }

  handlerError(error) {
    this.loading = false
    this.createAnimalError = true
    this.message = 'An error occured please try again later'
  }

  resetAddAnimalModal() {
    jQuery('#addAnimalModal').modal('hide')
    jQuery('#animalForm')[0].reset()
    this.createAnimalIsSuccess = false
    this.createAnimalError = false
    this.file = null
    this.isAddingAnimal = false
    this.chosenLanguage = 'English'
  }

  filterAnimalFunction() {
    this.searchItem = jQuery('#searchAnimal').val()
    this.filteredAnimals = this.animalsData.filter(
      (input) =>
        input.animal.toLowerCase().indexOf(this.searchItem.toLowerCase()) !== -1
    )
  }

  public languages = ['English', 'Hindi', 'Gujarati', 'Marathi']

  onClickOutside() {
    jQuery(document).ready(() => {
      jQuery('#addAnimalModal').on('hidden.bs.modal', () => {
        this.resetAddAnimalModal()
      })
    })
  }
}
